<style lang="scss">
  @use "../../assets/css/design-system/colors";
  @use "../../assets/css/design-system/utils";
  @use "../../assets/css/design-system/mixins";

  i {
    &.xxxs {
      font-size: utils.in_rem(7px);
    }
    &.xxs {
      font-size: utils.in_rem(8px);
    }
    &.ten-px {
      // added as part of updates to StatusTag.svelte (in-between existing xxs and xs sizes)
      font-size: utils.in_rem(10px);
    }
    &.xs {
      font-size: utils.in_rem(12px);
    }
    &.small {
      font-size: utils.in_rem(14px);
    }
    &.medium {
      font-size: utils.in_rem(16px);
    }
    &.large {
      font-size: utils.in_rem(20px);
    }
    &.xl {
      font-size: utils.in_rem(24px);
    }

    &.xxl {
      font-size: utils.in_rem(34px);
    }

    &.xxxl {
      font-size: utils.in_rem(54px);
    }

    &.cta-card {
      font-size: utils.in_rem(28px);
    }

    @include colors.utility_classes();

    &.type-ai {
      background: colors.get(aiGradient);
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .tooltip-icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>

<script>
  import Tooltip from "./Tooltip.svelte";

  let cls;
  export { cls as class };

  /** @type {"small" | "medium" | "large" | "xl"} */
  export let size = "medium";
  /** @type {"standard" | "ai"} */
  export let type = "standard";

  const faWeightIdentifiers = [
    "fa-regular",
    "far",
    "fa-light",
    "fal",
    "fa-solid",
    "fas",
    "fa-brands",
    "fab",
    "fa-kit",
    "fak",
  ];

  export let skeleton = false;
  export let placement;

  const ensureClass = (c, options) => {
    const currentClasses = c.split(" ");
    const overlap = options.filter((o) => currentClasses.includes(o));
    return overlap.length === 0 ? `${c} ${options[0]}` : c;
  };

  $: wrappedCls = skeleton ? "" : ensureClass(cls, faWeightIdentifiers);
</script>

{#if skeleton}
  <div class="{size} skeleton"></div>
{:else if $$slots.tooltip}
  <Tooltip
    {...placement ? { placement } : {}}
    let:onmouseenter
    let:onmouseleave
    let:onblur
    let:onfocus
  >
    <span slot="tooltip"><slot name="tooltip" /></span>
    <div
      class="tooltip-icon"
      role="button"
      tabindex="0"
      on:mouseenter={onmouseenter}
      on:mouseleave={onmouseleave}
      on:focus={onfocus}
      on:blur={onblur}
    >
      <i class="{wrappedCls} {size}"></i>
    </div>
  </Tooltip>
{:else}
  <i class="{wrappedCls} {size} type-{type}"></i>
{/if}
